// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9Q0sq","title":"styles_title__2NuwC"};